import { Badge, type BadgeProps } from "@mantine/core"

export function StatusBadge(props: BadgeProps) {
  return <Badge {...props} tt="uppercase" radius="md" miw={50} />
}
